import React, { Component } from 'react';
// import PlanningDetailsItem from '../../../Domain/PlanningDetailsItem'
import CaspianDatePicker from '../../../Elements/InputComponents/BaseInputs/CaspianDatePicker';
import ColButton from '../../../Elements/ColButton';
import ErrorMessage from '../../../Elements/ErrorMessage';
import OverWindow from '../../../Elements/OverWindow';
import PlanningStatusEnum from '../../../Enums/PlanningStatusEnum';
import mathHelper from '../../../Helpers/mathHelper';
import stringHelper from '../../../Helpers/stringHelper';
import PlanningDetailsItemService from '../../../Services/PlanningDetailsItemService';
import TargetRate from '../PlanningItem/TargetRate';
import ButtonFooterContainer from '../../../Elements/ButtonFooterContainer';

class PlanningDetailItemEditBox extends Component {
  constructor(props) {
    super(props);

    const tempSelectedItem = { ...props.selectedItem };
    tempSelectedItem.StartDate = this.getNewDate(tempSelectedItem.StartDate);
    tempSelectedItem.EndDate = this.getNewDate(tempSelectedItem.EndDate);
    if (tempSelectedItem.NumberOfPlannedAssignments === 0) {
      tempSelectedItem.NumberOfPlannedAssignments = tempSelectedItem.NumberOfContractedAssignments;
    }
    this.state = {
      selectedItem: tempSelectedItem,
      applyValue: false,
      targetAssignmentRate: this.getTargetAssignmentRate(tempSelectedItem),
      targetCompletionRate: this.getTargetCompletionRate(tempSelectedItem),
    };
    this.clickOnSubmit = this.clickOnSubmit.bind(this);
  }

  getTargetAssignmentRate(item) {
    const rate = [
      isNaN(item.TargetAssignmentRate1) ? 0 : item.TargetAssignmentRate1,
      isNaN(item.TargetAssignmentRate2) ? 0 : item.TargetAssignmentRate2,
      isNaN(item.TargetAssignmentRate3) ? 0 : item.TargetAssignmentRate3,
      isNaN(item.TargetAssignmentRate4) ? 0 : item.TargetAssignmentRate4,
    ];

    if (mathHelper.Sum(rate) !== 100) {
      return [30, 45, 25, 0];
    }
    return rate;
  }

  getTargetCompletionRate(item) {
    const rate = [
      isNaN(item.TargetCompletionRate1) ? 0 : item.TargetCompletionRate1,
      isNaN(item.TargetCompletionRate2) ? 0 : item.TargetCompletionRate2,
      isNaN(item.TargetCompletionRate3) ? 0 : item.TargetCompletionRate3,
      isNaN(item.TargetCompletionRate4) ? 0 : item.TargetCompletionRate4,
    ];

    if (mathHelper.Sum(rate) !== 100) {
      return [20, 30, 30, 20];
    }

    return rate;
  }

  getNewDate(oldDate) {
    if (typeof oldDate !== Date) {
      oldDate = new Date(oldDate);
    }
    // return new Date(oldDate.getFullYear(),oldDate.getMonth(),oldDate.getDate(),12,0,0);
    const twelveYearsAgo = new Date(new Date().getFullYear() - 20, new Date().getMonth(), new Date().getDate());
    if (oldDate < twelveYearsAgo) oldDate = new Date();
    return new Date(oldDate.getFullYear(), oldDate.getMonth(), oldDate.getDate(), 12, 0, 0);
  }

  clickOnSubmit() {
    // A Replaced period belongs to a pricing that a newer approved pricing superseded. It is kept as a
    // read-only record, and saving it here would send Status = ClientConfirmed and revive it. The backend
    // refuses the same thing; this just says why before the round trip.
    if (this.state.selectedItem.Status === PlanningStatusEnum.Replaced) {
      ErrorMessage.SetWarning(
        'This fieldwork period belongs to a pricing that has been replaced and cannot be edited.'
      );
      return;
    }

    const editedItem = this.state.selectedItem;
    editedItem.Status = PlanningStatusEnum.ClientConfirmed;
    if (this.state.applyValue) {
      if (mathHelper.Sum(this.state.targetAssignmentRate) === 100) {
        editedItem.TargetAssignmentRate1 = this.state.targetAssignmentRate[0];
        editedItem.TargetAssignmentRate2 = this.state.targetAssignmentRate[1];
        editedItem.TargetAssignmentRate3 = this.state.targetAssignmentRate[2];
        editedItem.TargetAssignmentRate4 = this.state.targetAssignmentRate[3];
      }

      if (mathHelper.Sum(this.state.targetCompletionRate) === 100) {
        editedItem.TargetCompletionRate1 = this.state.targetCompletionRate[0];
        editedItem.TargetCompletionRate2 = this.state.targetCompletionRate[1];
        editedItem.TargetCompletionRate3 = this.state.targetCompletionRate[2];
        editedItem.TargetCompletionRate4 = this.state.targetCompletionRate[3];
      }
    }

    PlanningDetailsItemService.EditPlanningDetailsItem(editedItem)
      .then(() => this.props.submitHandler())
      .catch((error) => {
        ErrorMessage.SetErrorMessage('PDIEB110');
      });
  }

  validityCheck() {
    return (
      this.state.selectedItem.NumberOfPlannedAssignments > 0 &&
      this.state.selectedItem.EndDate >= this.state.selectedItem.StartDate &&
      !(
        this.state.applyValue &&
        (mathHelper.Sum(this.state.targetAssignmentRate) !== 100 ||
          mathHelper.Sum(this.state.targetCompletionRate) !== 100)
      )
    );
  }

  renderStartDateField() {
    return (
      <div
        className='text-center border-0 col hover rounded p-1'
        key='colStartDate'
      >
        <CaspianDatePicker
          selected={this.state.selectedItem.StartDate}
          labelText='Start Date'
          onChange={(e) => {
            const newEndDate = this.state.selectedItem.EndDate < e ? e : this.state.selectedItem.EndDate;
            this.setState({
              selectedItem: {
                ...this.state.selectedItem,
                StartDate: e,
                EndDate: newEndDate,
              },
            });
          }}
        />
      </div>
    );
  }

  renderEndDateField() {
    return (
      <div
        className='col text-center border-0 hover rounded p-1'
        key='tdEndDate'
      >
        <CaspianDatePicker
          selected={this.state.selectedItem.EndDate}
          labelText='End Date'
          onChange={(e) => {
            const newStartDate = this.state.selectedItem.StartDate > e ? e : this.state.selectedItem.StartDate;
            this.setState({
              selectedItem: {
                ...this.state.selectedItem,
                EndDate: e,
                StartDate: newStartDate,
              },
            });
          }}
        />
      </div>
    );
  }

  renderTextField(key) {
    const bgclass = this.state.selectedItem[key] <= 0 ? 'bg-warning' : '';
    return (
      <div
        className='col text-center border-0 hover rounded p-1'
        key='tdNumberOfPlannedAssignment'
      >
        <label htmlFor={`${key}-textfieldid`}>{stringHelper.convertToWords(key)}</label>
        <br />
        <input
          name={key}
          id={`${key}-textfieldid`}
          key={`${key}-textfieldkey`}
          className={`text-center form-control ${bgclass}`}
          type='number'
          min='0'
          value={this.state.selectedItem[key]}
          onChange={(e) => {
            let numval = parseInt(e.target.value);
            numval = isNaN(numval) ? 0 : numval;
            const temp = this.state.selectedItem;
            temp[key] = numval;
            this.setState({
              selectedItem: temp,
            });
          }}
        />
      </div>
    );
  }

  renderButton(text, onClick) {
    return (
      <ColButton
        text='Save'
        onClick={onClick}
        disabled={this.validityCheck()}
      />
    );
  }

  renderApplyTargetRateCheckBox() {
    return (
      <div className='col hover rounded p-1'>
        <p className='m-1 text-center'>Apply Target Rates</p>
        <div className='m-1 d-flex align-items-center justify-content-center '>
          <input
            type='checkbox'
            checked={this.state.applyValue}
            onChange={(e) => {
              this.setState({ applyValue: e.target.checked });
            }}
          />
        </div>
      </div>
    );
  }

  renderTargetRate(labeltext, ratename) {
    return (
      <div className='col hover rounded p-1'>
        <p className='m-1 text-center'>Target {labeltext} Rate (%)</p>
        <TargetRate
          rates={this.state[ratename]}
          disabled={!this.state.applyValue}
          onChange={(value) => {
            this.setState({ [ratename]: value });
          }}
        />
      </div>
    );
  }

  render() {
    return (
      <OverWindow
        clickOnCancel={this.props.cancelHandler}
        title={this.props.caption}
        closeOnClickOutside={false}
        minHeight={500}
      >
        <div
          className='form-group container-fluid'
          style={{ minHeight: '300px' }}
        >
          {/* <h6>{this.props.caption}</h6> */}
          <div className='container-fluid'>
            <div className='row'>
              {this.renderStartDateField()}
              {this.renderEndDateField()}
              {this.renderTextField('NumberOfPlannedAssignments')}
            </div>
            <div className='row mt-5'>{this.renderApplyTargetRateCheckBox()}</div>

            <div className='row mt-5'>
              {this.renderTargetRate('Assignment', 'targetAssignmentRate')}
              {this.renderTargetRate('Completion', 'targetCompletionRate')}
            </div>
          </div>
        </div>

        <ButtonFooterContainer>
          <ColButton
            text='Cancel'
            onClick={() => {
              this.props.cancelHandler();
            }}
          />
          <ColButton
            text='Save'
            onClick={this.clickOnSubmit}
            disabled={!this.validityCheck()}
          />
        </ButtonFooterContainer>
      </OverWindow>
    );
  }
}

export default PlanningDetailItemEditBox;
